/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.apiFetch();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
  timber.accordion();
  timber.sideTumbsNav();
  timber.videoThumb();
  timber.gdpr();
  timber.zoom();
  timber.type();
  timber.readmore();
  timber.dropdown();
  timber.openStore();
  timber.filter();

  $('.lazyloading').lazy({});
  $('.fancybox').fancybox();

};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  
    timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
      'onDrawerOpen': ajaxCart.load
    });
  
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.apiFetch = function () {
  var truncate = function (text) {
    var string = text.substring(0, 120);
    if (text.length > 120) {
      string += '&hellip;'
    }

    return string;
  };

  $('.js-api-fetch').each(function() {
    var $this = $(this);
    var api = $this.data('api');
    var limit = $this.data('limit'); // optional limitation
    var itemClass = $this.data('item-class');

    $.ajax({
      url: api,
      data: {},
      dataType: 'jsonp',
      success: function(data) {
        if (data) {
          // get length of files
          var length = limit ? limit : data.length;
          var items = '';

          for (var i = 0; i < length; i++) {
            var el = data[i];
            items += '<div class="' + itemClass + '">' +
              '<a href="' + el.url + '" target="_blank" class="social-item-link">' +
                '<img src="' + el.photo + '" class="social-item-link__image" />' +
                '<span class="social-item-link__content"><span class="social-item-link__text">' +
                  truncate(el.text) +
                '</span></span>' +
              '</a>' +
            '</div>';
          }

          $this.html(items);
        }
      }
    });
  });
};

timber.zoom = function(){

  if($(window).width() > 768 ){
    $('.zoom-img').zoom();
  }
};

timber.dropdown = function(){
  $('.shop-wrapper')
    .addClass('cache')
    .parent().bind('mouseover focusin', function() {

    $(this).find('ul').removeClass('cache');

  }).bind('mouseout focusout', function() {

    $(this).find('ul').addClass('cache');

  }).on('touchstart', function (e) {

    'use strict';
    var $this = $(this);
    if ($this.hasClass('hover')) {
      $this.removeClass('hover');
      return true;
    } else {
      e.preventDefault();

      $('.main-nav__dropdown ul').addClass('cache');

      $this
        .addClass('hover')
        .find('ul').removeClass('cache');

      return false;
    }
  });
};

timber.accordion = function () {
  $('.accordion__title').click(function(e) {
    e.preventDefault();
    $(this).toggleClass('active').next('.accordion__content').toggle('fast');
  });
};

timber.gdpr = function(){
  $('input#gdpr').change(function() {
    if ($('input#gdpr').is(':checked')) {
      $('#contact-submit').prop("disabled", false);

    } else {
      $('#contact-submit').prop("disabled", true);
    }
  });

};

timber.readmore = function() {
  $('.product-single__description-intro').readmore({
    speed: 75,
    lessLink: '<a href="#" class="description-more">Lees minder <i class="icon icon-minus"></i></a>',
    moreLink: '<a href="#" class="description-more">Lees meer <i class="icon icon-plus"></i></a>',
    collapsedHeight: 50
  });
};


timber.openStore = function(){

  function addZero(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  var d = new Date();
  var hours = addZero( ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2) );

  $( ".contact-date" ).each(function( index ) {
    var dag = $(this).find('.contact-day').text().split(' ');
    var today = ('0' + d.getDate()).slice(-2) + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + d.getFullYear();

    if( dag[1] === today){

      var hourVM = $(this).find('.contact-VMhour').text().split('-');
      var hourVMone = hourVM[0];
      var hourVMtwo = hourVM[1];

      var hourNM = $(this).find('.contact-NMhour').text().split('-');
      var hourNMone = hourNM[0];
      var hourNMtwo = hourNM[1];

      var startVM = hourVMone;
      var startNM = hourNMone;
      var endVM = hourVMtwo;
      var endNM = hourNMtwo;

      if( (hours >= startVM) && (hours < endVM ) ) {
        $('.store-time').addClass('opened').empty().append('<i class="icon icon-clock"></i> Nu geopend</span>');
      }

      if( (hours >= startNM) && (hours < endNM ) ) {
        $('.store-time').addClass('opened').empty().append('<i class="icon icon-clock"></i> Nu geopend</span>');
      }
    }
  });


};

timber.filter = function(){
  $('.filter-group-materiaal-kast').removeClass('pt-group-expanded');
  $('.filter-group-zwitsers-horloge').removeClass('pt-group-expanded');
  $('.filter-group-diameter-kast').removeClass('pt-group-expanded');
  $('.filter-group-gewicht').removeClass('pt-group-expanded');
  $('.filter-group-xmucqklt').removeClass('pt-group-expanded');
  $('.filter-group-caliber').removeClass('pt-group-expanded');
  $('.filter-group-rbmgdyxe').removeClass('pt-group-expanded');
};

timber.type = function(){
  if ($('.typed').length) {
    var options = {
      strings: ["horlogedokter.be", "uurwerken &amp; juwelen", "horlogedokter.be"],
      typeSpeed: 100,
      backSpeed: 90,
      smartBackspace: false,
      showCursor: false,
      loop: false
    };

    var typed = new Typed(".typed", options);
  }
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {
    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      if (newImg && el) {
        // TODO: this is not working (for products with variants)
        // Shopify.Image.switchImage(newImg, el, timber.switchImage);
      }
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("in winkelwagen");
      $quantityElements.show();

      // Adjust stock message
      var isInStock = window.variantsInStock[variant.id];
      var noStockHiddenInput = document.querySelector('.js-no-stock-hidden-input');
      var noStockMessage = document.querySelector('.js-no-stock-message');
      var inStockMessage = document.querySelector('.js-in-stock-message');

      if (isInStock != undefined && isInStock === false) {
        // show corresponding message
        noStockMessage.classList.remove('hide');
        inStockMessage.classList.add('hide');

        // add hidden input with line item property to form
        if (!noStockHiddenInput) {

          var hiddenInput = document.createElement('input');
          hiddenInput.setAttribute('type', 'hidden');
          hiddenInput.setAttribute('name', 'properties[Op bestelling leverbaar]');
          hiddenInput.setAttribute('value', 'Levertijd +/- 2 weken');
          hiddenInput.classList.add('js-no-stock-hidden-input');
          document.querySelector('#AddToCartForm').appendChild(hiddenInput);
        }
      } else if (isInStock === true) {
        // show corresponding message
        noStockMessage.classList.add('hide');
        inStockMessage.classList.remove('hide');

        // remove hidden input with line item property from form
        if (noStockHiddenInput) {
          noStockHiddenInput.parentNode.removeChild(noStockHiddenInput);
        }
      }
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Uitverkocht");
      $quantityElements.hide();
    }
    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html("Vergelijken met" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }
  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Niet beschikbaar");
    $quantityElements.hide();
  }
};


// Main function of the thumb navigation next to the product photo slider.
timber.sideTumbsNav = function() {
  var $thumbNav = $('.product-single__side-thumbs-nav');

  if($thumbNav.length) {
    var $arrows = $thumbNav.find('.product-single__thumb-nav-arrow');
    var $cyclePager = $thumbNav.find('.cycle-pager');
    var nrOfThumbs = $cyclePager.children('li').length;
    var $productPhoto = $('#ProductPhoto');
    var $cycleSlideshow = $productPhoto.find('.cycle-slideshow');
    var $thumbs = $thumbNav.find('.product-single__side-thumbs');
    var navArrowHeight = parseInt($thumbNav.find('.product-single__thumb-nav-arrow').first().height());
    var productPhotoHeight = parseInt($productPhoto.height());
    var thumbHeight = parseInt($cyclePager.children('li').first().height()) + parseInt($cyclePager.children('li').first().css('margin-bottom'));
    var thumbMargin =  parseInt($cyclePager.children('li').first().css('margin-bottom'));

    $arrows.click(function() {
      timber._moveSideTumbNav($(this).data('thumb-nav-action'), $thumbNav, $arrows);
    });

    $cycleSlideshow.on( 'cycle-before', function(event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) {
      timber._moveSideTumbNav(null, $thumbNav, $arrows, optionHash.nextSlide);
    });

    if(productPhotoHeight >=  parseInt($thumbs.height()) + 2 * navArrowHeight) {
      $thumbs.css({'max-height': Math.floor(productPhotoHeight * 0.7 /thumbHeight) * thumbHeight - 2 * navArrowHeight - thumbMargin });
    }
    var maxHeight = $thumbs.css('max-height');
    if(nrOfThumbs <= Math.round((parseInt(maxHeight) - thumbMargin) / thumbHeight) ) {
      $arrows.remove();
    }
    $arrows.show();
  }
};


// action 'up' or 'down'
// $thumbNav , $arrows (jquery DOM elements)
// position: use to set position directly, action parameter not necessary when position parameter is present
timber._moveSideTumbNav = function(action, $thumbNav, $arrows, position) {
  var $cyclePager = $thumbNav.find('.cycle-pager');
  var cyclePagerPosition = parseInt($cyclePager.css('top'));
  var nrOfThumbs = $cyclePager.children('li').length;
  var thumbHeight = parseInt($cyclePager.children('li').first().height()) + parseInt($cyclePager.children('li').first().css('margin-bottom'));
  var $thumbs = $thumbNav.find('.product-single__side-thumbs');
  var thumbsHeight = parseInt($thumbs.height());
  var nrVisibleThumbs = Math.round(thumbsHeight / thumbHeight);
  var newTop;
  var endTop = - ( nrOfThumbs - nrVisibleThumbs ) * thumbHeight;

  if(position == null ) {
    if(action === 'down') {
      newTop = cyclePagerPosition -  thumbHeight;
      if(newTop <= - ( nrOfThumbs - nrVisibleThumbs ) * thumbHeight ) {
        newTop = endTop;
      }
    } else { //up
      newTop = cyclePagerPosition + thumbHeight;
      if(newTop > 0) {
        newTop = 0;
      }
    }
  } else {
    var offset = Math.round((nrVisibleThumbs) / 2);
    if( position <= offset - 1 ) {
      newTop = 0;
    } else if (position >= nrOfThumbs - offset) {
      newTop = endTop;
    } else {
      newTop = ( - position + offset ) * thumbHeight;
    }
  }


  // Move the navigation and set arrow classes
  $arrows.removeClass('js-inactive');
  if(newTop === 0) {
    $arrows.eq(0).addClass('js-inactive');
  } else if(newTop === endTop) {
    $arrows.eq(1).addClass('js-inactive');
  }

  $cyclePager.css({top: newTop});
};


timber.productImageSwitch = function () {

  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      main.cache.$thumbImages.parent().removeClass('cycle-pager-active');
      $(this).parent().addClass('cycle-pager-active');
      evt.preventDefault();
      var newImage = $(this).attr('href');
      var $productPhoto = $('#ProductPhoto');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};




timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};


timber.videoThumb = function() {

  if($('#ProductThumbs').hasClass('has-video')) {
    $('#ProductThumbs .thumb').click(function() {

      if( $(this).hasClass('video-thumb')) {
        $('#ProductVideo').show();

        $("#ProductVideo").get(0).play();

        $('#ProductPhoto').hide();
        $('#ProductThumbs .thumb').removeClass('cycle-pager-active');
      }
      else {
        $('#ProductVideo').hide();

        $("#ProductVideo").get(0).currentTime = 0;
        $("#ProductVideo").get(0).pause();

        $('#ProductPhoto').show();
      }

    });
  }

};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
 if (timber.cache.$changeView.length) {
   timber.cache.$changeView.on('click', function() {
     var view = $(this).data('view'),
         url = document.URL,
         urlWithoutHash = url.split('#')[0],
         hasParams = url.indexOf('?') > -1,
         location = '';

     if (hasParams) {
       location = replaceUrlParam(urlWithoutHash, 'view', view);
     } else {
       location = urlWithoutHash + '?view=' + view;
     }

     if(url.indexOf('#') > -1) {
       var hash = url.substring(url.indexOf('#')+1);
       location += '#' + hash;
     }

     window.location = location;
   });
 }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);
